import BaseMystery from '../BaseMystery'

const FourthJoyfulMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/b/bassano/francesc/presenta.jpg",
		"https://www.wga.hu/art/a/angelico/04/3predel4.jpg",
		"https://www.wga.hu/art/a/angelico/09/cells/10_prese.jpg",
		"https://www.wga.hu/art/b/bergogno/presentat.jpg",
		"https://www.wga.hu/art/b/broederl/02right1.jpg",
		"https://www.wga.hu/art/c/carpacci/5/02prese.jpg",
		"https://www.wga.hu/art/c/celesti/presenta.jpg",
		"https://www.wga.hu/art/c/champaig/philippe/presenta.jpg",
		"https://www.wga.hu/art/g/gentile/adormagi/adormagr.jpg",
		"https://www.wga.hu/art/g/giotto/padova/3christ/chris03.jpg",
		"https://www.wga.hu/art/g/giotto/assisi/lower/ceiling/04christ.jpg",
		"https://www.wga.hu/art/g/guido/06poly.jpg",
		"https://www.wga.hu/art/h/herlin/nordlin3.jpg",
		"https://www.wga.hu/art/l/lochner/present.jpg",
		// "https://www.wga.hu/art/p/palma/giovane/2/12presen.jpg", (Doesn't crop well)
		"https://www.wga.hu/art/r/rembrand/11biblic/10newtes.jpg",
		"https://www.wga.hu/art/r/robusti/domenico/present.jpg",
		"https://www.wga.hu/art/r/romanino/presenta.jpg",
		"https://www.wga.hu/art/s/scorel/presenta.jpg",
		"https://www.wga.hu/art/t/tintoret/2_1550s/07prese.jpg",
		"https://www.wga.hu/art/v/vos/cornelis/rosary2.jpg",
	];

	const scriptureQuote = "\"Now, Master, you may let your servant go in peace, according to your word, for my eyes have seen your salvation, which you prepared in sight of all the peoples, a light for revelation to the Gentiles, and glory for your people Israel.\"";
	const scriptureCitation = "Luke 2:29-32 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Luke%202%3A22-35&version=NABRE";

	return (
		<BaseMystery titleText="The Presentation in the Temple"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={true} />
	);
};

export default FourthJoyfulMystery;